// src/types/booking.ts
function priceTierForQuantity(tiers, quantity) {
  if (tiers.length === 0) return void 0;
  return tiers.find((t) => quantity >= t.paxFrom && quantity <= t.paxTo) ?? tiers[0];
}
function lineTotalForParticipant(pricing, quantity) {
  if (!pricing || quantity <= 0) return 0;
  const tier = priceTierForQuantity(pricing.tiers, quantity);
  if (!tier) return 0;
  return tier.fixedPrice + tier.pricePerParticipant * quantity;
}
function bookingTotal(slot, quantities) {
  return slot.pricing.reduce((sum, p) => {
    const q = quantities[p.participantTypeAlias] ?? 0;
    return sum + lineTotalForParticipant(p, q);
  }, 0);
}

// src/constants/allowedEmails.ts
var ALLOWED_EMAILS = [
  // Add allowed email addresses here:
  // 'user@example.com',
];
function isEmailAllowed(email) {
  if (ALLOWED_EMAILS.length === 0) return true;
  if (!email) return false;
  return ALLOWED_EMAILS.includes(email.toLowerCase());
}
export {
  ALLOWED_EMAILS,
  bookingTotal,
  isEmailAllowed,
  lineTotalForParticipant,
  priceTierForQuantity
};
